const { default: UploadButton } = require("components/base/UploadButton");
const { default: Modal } = require("components/Modals");
const { CTA_TITLES } = require("components/UserCardList/constants/ctaTitles");

const ResumeWarningModal = ({
  loadingWidget,
  onClose,
  onUploadClickButton,
}) => {
  return (
    <Modal
      isVisible
      title={<span className="text-red-500">Warning!</span>}
      onClose={onClose}
      className="max-h-[90vh] border-2 overflow-x-hidden xl:!w-7/12 md:!w-10/12 !w-[95%]"
      subTitle={
        <>
          <br />
          <span>Are you sure you want to upload resume for this user?</span>
          <br />
          <span>Uploading a file will replace current resume.</span>
        </>
      }
    >
      <div className="w-full flex justify-center items-center">
        <UploadButton
          onClick={onUploadClickButton}
          label="Upload Resume"
          title={CTA_TITLES.uploadResume}
          loadingWidget={loadingWidget}
          className="text-gray-600 hover:text-sky-500 shadow-lg border-b-2 hover:border-sky-500 py-2 px-3 rounded-lg text-center"
        />
      </div>
    </Modal>
  );
};

export default ResumeWarningModal;
